module.exports = "<div ng-bind-html=\"vm.html\">\n\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/side-menu/components/html/html.template.html
// module id = 109
// module chunks = 0